import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  inheritAttrs: false,
  name: "ToggleableField"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: String,
    default: '',
    required: true
  },
  edit: {
    type: Boolean,
    required: false,
    default: false
  },
  multiLine: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { expose }) {
  expose();





const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})